import { useEffect, useState } from 'react';
import { KioskCarousel } from './kiosk-carousel';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabase = createClient(supabaseUrl, supabaseAnonKey);

interface Kiosk {
  id: string;
  business_name: string;
  logo_url: string | null;
}

export function KiosksSection() {
  const [kiosks, setKiosks] = useState<Kiosk[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadKiosks() {
      try {
        // Récupérer tous les kiosks actifs
        const { data: kiosksData, error: kiosksError } = await supabase
          .from('kiosk_profiles')
          .select('id, business_name, logo_url')
          .eq('is_active', true)
          .eq('is_live', true)
          .limit(20);

        if (kiosksError) throw kiosksError;

        if (kiosksData) {
          // Vérifier quels kiosks ont des produits actifs
          const kiosksWithProducts: Kiosk[] = [];
          
          for (const kiosk of kiosksData) {
            const { data: productsData } = await supabase
              .from('kiosk_products')
              .select('id')
              .eq('kiosk_id', kiosk.id)
              .eq('is_active', true)
              .limit(1);
            
            if (productsData && productsData.length > 0) {
              kiosksWithProducts.push({
                id: kiosk.id,
                business_name: kiosk.business_name,
                logo_url: kiosk.logo_url
              });
            }
          }
          
          setKiosks(kiosksWithProducts);
        }
      } catch (error) {
        console.error('Error loading kiosks:', error);
        setKiosks([]);
      } finally {
        setLoading(false);
      }
    }
    loadKiosks();
  }, []);

  if (loading) {
    return (
      <div className="py-12">
        <div className="space-y-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-4">
              <div className="h-6 w-48 animate-pulse rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="h-[275px] w-full animate-pulse rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!kiosks.length) {
    return (
      <div className="py-12 text-center">
        <p className="text-lg text-neutral-500 dark:text-neutral-400">
          Aucune boutique disponible pour le moment
        </p>
      </div>
    );
  }

  return (
    <section className="px-4 py-8">
      <div className="w-full">
        {kiosks.map((kiosk) => (
          <KioskCarousel key={kiosk.id} kiosk={kiosk} />
        ))}
      </div>
    </section>
  );
}

